 export const googleAnalyticsCode = `G-NB3DRFR61R`;